import { CommonModule } from '@angular/common';
import { Component, inject, input, output, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { DropdownComponent } from 'src/app/components/shared/dropdown/dropdown.component';
import { AddResumeReference } from 'src/app/models/resume/add-resume';
import { DropDownKeywords, DropdownOption } from 'src/app/models/shared/dropdown-option';
import { DropdownService } from 'src/app/services/dropdown.service';
import { ResumeService } from 'src/app/services/resume.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-reference',
  imports: [CommonModule, ReactiveFormsModule, NgxMaskDirective, DropdownComponent],
  templateUrl: './modal-reference.component.html',
  styleUrl: './modal-reference.component.css'
})
export class ModalReferenceComponent {
  public resumeId = input<number | null>(null);
  public onResumeReference = output<AddResumeReference>();

  private readonly resumeService = inject(ResumeService);
  private readonly dropdownService = inject(DropdownService);

  public form = new FormGroup({
    id: new FormControl(0),
    resumeId: new FormControl(0),
    firstName: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
    lastName: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
    companyId: new FormControl(null, [Validators.required]),
    company: new FormControl('', [Validators.maxLength(1000)]),
    positionId: new FormControl(null, [Validators.required]),
    position: new FormControl('', [Validators.maxLength(1000)]),
    phone: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
    email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(1000)]),
    isEnabled: new FormControl(true)
  });

  isLoading = signal<boolean>(false);

  positions: DropdownOption[] = [];
  companies: DropdownOption[] = [];

  ngOnInit(): void {
    this.getOptions();
  }

  getOptions() {
    this.dropdownService.GetOptions(DropDownKeywords.Positions,null,undefined,true).subscribe({
      next: res => {
        this.positions = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.Companies,null,undefined,true).subscribe({
      next: res => {
        this.companies = res;
      }
    });
  }

  reset() {
    this.form.reset();
    this.form.patchValue({
      isEnabled: true
    });
  }

  closeModal() {
    this.reset();
    let divModal = document.getElementById('modalReference');
    let modal = (window as any).bootstrap.Modal.getInstance(divModal);
    modal.hide();
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const resumeReference = {
      ...this.form.getRawValue(),
      position: this.positions.find(x => x.id === this.form.get('positionId')?.value)?.text,
      company: this.companies?.find(company => company.id == this.form.getRawValue().companyId)?.text,
      resumeId: this.resumeId()
    } as any as AddResumeReference;

    if (this.resumeId()) {
      this.isLoading.set(true);
      this.resumeService.addResumeReference({
        ...resumeReference
      }).subscribe({
        next: res => {
          this.isLoading.set(false);
          this.onResumeReference.emit(resumeReference);
          this.closeModal();
        }, error: res => {
          this.isLoading.set(false);
          Swal.fire({
            title: 'Error',
            text: 'Ocurrió un error al guardar el registro.',
            icon: 'error',
            confirmButtonColor: '#d33'
          });
        }
      })
    } else {
      this.onResumeReference.emit(resumeReference);
      this.closeModal();
    }
  }
}
